<template>
  <div class="details-container">
    <template v-if="hasSelectedSlug">
      <!-- Mirror Details Card -->
      <div class="slug-details-card-wrapper">
        <MirrorDetailsCard
          v-if="slug"
          :slug="slug"
          :activityType="normalizeType(slug.item_type)"
        />
      </div>

      <!-- Mirror Notes and body -->
      <div v-if="!hasNotesReference" class="mt-3">
        <v-row
          v-for="(item, index) in notesWithBodyFormatted"
          :key="index"
          no-gutters
        >
          <v-col cols="4" class="pr-2">
            <MirrorDetailsNote
              v-for="(itemNote, indexNotes) in item.notes"
              :key="indexNotes"
              class="mt-0"
              :mark="itemNote.mark"
              :note="itemNote.note"
            />
          </v-col>

          <v-col
            cols="8"
            class="card-body-wrapper d-flex"
            :class="{
              'card-body-wrapper-first': !index,
              'card-body-wrapper-last': checkIsLastNote(index),
            }"
          >
            <MirrorBodyDetailsCard
              :body="item.text"
              elevation="0"
              :hasNote="hasNote(item)"
            />
          </v-col>
        </v-row>
      </div>

      <!-- Mirror Notes and body without reference-->
      <div v-else class="mt-3">
        <v-row no-gutters>
          <v-col cols="4" class="pr-2">
            <MirrorDetailsNote
              v-for="(note, index) in notes"
              :key="index"
              :mark="index"
              :note="note"
            />
          </v-col>

          <v-col cols="8" class="pl-0">
            <MirrorBodyDetailsCard :body="body" />
          </v-col>
        </v-row>
      </div>
    </template>
    <Error
      v-else
      :textTitle="'Tão <span>vazio</span> por aqui...'"
      :textDescription="'Não encontramos nenhuma atividade selecionada.'"
      :imageTitle="'hungry'"
      class="no-activities inside"
    />
  </div>
</template>
<script>
import { formatSeconds } from '@/utils/date.js';
import { escapeHTML } from '@/utils/text.js';
import { normalizeType } from '@/utils/mirrorFormatter.js';
import MirrorDetailsCard from '@/components/mirrors/MirrorDetails/MirrorDetailsCard.vue';
import MirrorDetailsNote from '@/components/mirrors/MirrorDetailsNote.vue';
import MirrorBodyDetailsCard from '@/components/mirrors/MirrorBodyDetailsCard.vue';
import Error from '@/components/shared/Error.vue';

export default {
  name: 'MirrorDetails',
  components: {
    MirrorDetailsCard,
    MirrorBodyDetailsCard,
    Error,
    MirrorDetailsNote,
  },
  props: {
    slug: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      emptyField: '--',
      loadingMirror: false,
    };
  },

  computed: {
    hasSelectedSlug() {
      const { id } = this.slug || {};
      return !!id;
    },
    hasNotesReference() {
      return (this.slug.notes_with_body || []).every(
        value => !value.text || !value.text.length,
      );
    },
    notes() {
      return (this.slug.notes_with_body || []).map(value => value.note);
    },
    body() {
      const { body = '' } = this.slug || {};
      return escapeHTML(body);
    },
    notesWithBodyFormatted() {
      let mark = -1;

      return this.slug.notes_with_body.map(value => {
        const notes = value.notes.map(note => {
          mark = mark + 1;

          return { note, mark: mark };
        });

        return { ...value, notes };
      });
    },
  },
  methods: {
    normalizeType,
    formatSeconds,
    escapeHTML,
    checkIsLastNote(index) {
      const { notes_with_body = [] } = this.slug || {};
      return index === notes_with_body.length - 1;
    },
    formattedBody(value) {
      return value.reduce((acc, curr) => {
        acc = acc += curr;
        return acc;
      }, '');
    },
    hasNote(noteWithBody) {
      return !!noteWithBody.notes.length;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/theme.scss';
@import '@/assets/scss/theme-v2.scss';
@import '@/assets/scss/fixes.scss';

.details-container {
  background-color: $color-gray-lighter;
  overflow-x: hidden;
  max-height: 78vh;

  @include for-size(desktop-down) {
    max-height: 74vh;
  }

  @include for-size(ultra-wide-up) {
    max-height: 80vh;
  }
  .card-body-wrapper {
    background: white;
    padding-left: 4px;
    padding-top: 0;
  }
  .card-body-wrapper-first {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    box-shadow: 0 2px 8px 0 rgba($color-gray-darker, 0.08);
  }
  .card-body-wrapper-last {
    box-shadow: 0 5px 8px 0 rgba($color-gray-darker, 0.08);
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  .slug-details-card-wrapper {
    position: sticky !important;
    top: 0;
    z-index: 1;
  }
}
</style>
